var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40625 0C1.07733 0 0 1.04467 0 2.33333V21.6667C0 22.9553 1.07733 24 2.40625 24H7.21875C8.5477 24 9.62501 22.9553 9.62501 21.6667V2.33333C9.62501 1.04467 8.5477 0 7.21875 0H2.40625ZM14.7813 0C13.4523 0 12.375 1.04467 12.375 2.33333V21.6667C12.375 22.9553 13.4523 24 14.7813 24H19.5938C20.9227 24 22 22.9553 22 21.6667V2.33333C22 1.04467 20.9227 0 19.5938 0H14.7813Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.56aa6d1a89d0375512ed785afc3a8b20.svg";
export { ForwardRef as ReactComponent };